import { ENABLE_LCA_FACILITIES_PROTOTYPE_UI } from "../../../config/constants";
import FacilityDetailsDrawer from "../facilityDrawer/FacilityDetailsDrawer";
import { FacilityDetailsModalProps } from "../facilityDrawer/types/facilityDrawer.types";
import FacilityDetailsModalLegacy from "./legacy/FacilityDetailsModalLegacy";

const FacilityDetailsModal = (props: FacilityDetailsModalProps) =>
  ENABLE_LCA_FACILITIES_PROTOTYPE_UI ? (
    <FacilityDetailsDrawer {...props} />
  ) : (
    <FacilityDetailsModalLegacy {...props} />
  );

export default FacilityDetailsModal;
export type { FacilityDetailsModalProps };
